import { CONSENT_BASIS_OPTIONS, PRODUCT_INTEREST_OPTIONS, type ContactDraft } from "./types";

function formatProfileLabel(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return "—";
  try {
    return new URL(trimmed).hostname.replace(/^www\./, "");
  } catch {
    return trimmed;
  }
}

export function ContactIdentityForm({
  draft,
  editing,
  onChange,
}: {
  draft: ContactDraft;
  editing: boolean;
  onChange: (patch: Partial<ContactDraft>) => void;
}) {
  const interestValues = PRODUCT_INTEREST_OPTIONS.filter(({ key }) => draft.product_interest[key]).map(({ label }) => label);
  const profileUrl = draft.source_url?.trim();

  if (!editing) {
    return (
      <dl className="contact-kv">
        <dt>Email</dt>
        <dd>{draft.email || "—"}</dd>
        <dt>Phone</dt>
        <dd>{draft.phone || "—"}</dd>
        <dt>Title</dt>
        <dd>{draft.title || "—"}</dd>
        <dt>Profile URL</dt>
        <dd>
          {profileUrl ? (
            <a href={profileUrl} target="_blank" rel="noreferrer">
              {formatProfileLabel(profileUrl)}
            </a>
          ) : (
            "—"
          )}
        </dd>
        <dt>Consent</dt>
        <dd>{draft.consent_basis || "—"}</dd>
        <dt>Product Interest</dt>
        <dd>{interestValues.length ? interestValues.join(", ") : "—"}</dd>
      </dl>
    );
  }

  return (
    <div className="contact-form-grid">
      <label className="field">
        First name
        <input value={draft.first_name} onChange={(e) => onChange({ first_name: e.target.value })} />
      </label>
      <label className="field">
        Last name
        <input value={draft.last_name} onChange={(e) => onChange({ last_name: e.target.value })} />
      </label>
      <label className="field">
        Email
        <input type="email" value={draft.email} onChange={(e) => onChange({ email: e.target.value })} />
      </label>
      <label className="field">
        Phone
        <input value={draft.phone} onChange={(e) => onChange({ phone: e.target.value })} />
      </label>
      <label className="field">
        Title
        <input value={draft.title} onChange={(e) => onChange({ title: e.target.value })} />
      </label>
      <label className="field">
        Consent basis
        <select value={draft.consent_basis} onChange={(e) => onChange({ consent_basis: e.target.value })}>
          {CONSENT_BASIS_OPTIONS.map((opt) => (
            <option key={opt.value || "empty"} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </label>
      <div className="field">
        <span>Product interest</span>
        <div className="checkbox-group">
          {PRODUCT_INTEREST_OPTIONS.map(({ key, label }) => (
            <label key={key} className="field checkbox-field">
              <input
                type="checkbox"
                checked={draft.product_interest[key]}
                onChange={(e) => onChange({
                  product_interest: {
                    ...draft.product_interest,
                    [key]: e.target.checked,
                  },
                })}
              />
              {label}
            </label>
          ))}
        </div>
      </div>
      {draft.consent_basis === "public_professional" ? (
        <label className="field">
          Profile URL (optional)
          <input
            value={draft.source_url}
            onChange={(e) => onChange({ source_url: e.target.value })}
            placeholder="https://…"
          />
        </label>
      ) : null}
    </div>
  );
}
